document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('recently-viewed')) {
    class RecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.fetchAttempts = 0;

        // Try immediate initialization for fastest loading
        setTimeout(() => {
          this.init();
        }, 100);

        // Keep lazy loading as backup in case immediate fails
        if (typeof window.initLazyScript === 'function') {
          window.initLazyScript(this, () => {
            if (this.innerHTML.trim() === '') {
              this.init();
            }
          }, 500);
        }
      }

      async init() {
        const searchQuery = this.getSearchQuery();

        if (!searchQuery) {
          return;
        }

        try {
          const fetchUrl = `${this.dataset.url}&q=${searchQuery}`;

          const response = await fetch(fetchUrl);
          if (!response.ok) throw new Error(response.status);

          const responseText = await response.text();

          // Let's try a different approach - parse as HTML directly
          const parser = new DOMParser();
          const doc = parser.parseFromString(responseText, 'text/html');
          const directEl = doc.querySelector('recently-viewed');

          if (directEl) {

            // Try updating with the direct element
            this.innerHTML = directEl.innerHTML;

            if (typeof window.buyo_init === 'function') {
              window.buyo_init();
            }
            return; // Exit early if this works
          }

          // Fallback to original template method
          const tmpl = document.createElement('template');
          tmpl.innerHTML = responseText;

          const el = tmpl.content.querySelector('recently-viewed');

          if (el && el.hasChildNodes()) {
            this.innerHTML = el.innerHTML;
          }

          if (typeof window.buyo_init === 'function') {
            window.buyo_init();
          }
        } catch (error) {
          console.error('RecentlyViewed: Fetch error:', error);
          this.fetchAttempts += 1;

          if (this.fetchAttempts === 3) {
            console.error('RecentlyViewed: Max fetch attempts reached');
          } else {
            this.init();
          }
        }
      }

      getSearchQuery() {
        const items = JSON.parse(localStorage.getItem('cc-recently-viewed') || '[]');

        if (this.dataset.exclude && items.includes(Number(this.dataset.exclude))) {
          items.splice(items.indexOf(Number(this.dataset.exclude)), 1);
        }

        const query = items.map((item) => `id:${item}`).slice(0, this.dataset.limit).join(' OR ');
        return query;
      }
    }

    customElements.define('recently-viewed', RecentlyViewed);
  }
});
